import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthModule } from 'src/app/auth/auth.module';
import { ErrorModule } from 'src/app/error/error.module';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () =>
      import('src/app/admin/admin.module').then(mod => mod.AdminModule)
  },
  {
    path: 'advisor',
    loadChildren: () =>
      import('src/app/advisor/advisor.module').then(mod => mod.AdvisorModule)
  },
  // auth, Routing from auth-routing.module imported via AuthModule
  {
    path: 'contract',
    loadChildren: () =>
      import('src/app/contract/contract.module').then(mod => mod.ContractModule)
  },
  // // error, Routing from error-routing.module imported via ErrorModule
  {
    path: 'general',
    loadChildren: () =>
      import('src/app/general/general.module').then(mod => mod.GeneralModule)
  },
  {
    path: 'instruction',
    loadChildren: () =>
      import('src/app/instruction/instruction.module').then(
        mod => mod.InstructionModule
      )
  },
  {
    path: 'fee-upload',
    loadChildren: () =>
      import('src/app/fee-upload/fee-upload.module').then(
        mod => mod.FeeUploadModule
      )
  },
  {
    path: 'contract',
    loadChildren: () =>
      import('src/app/contract/contract.module').then(mod => mod.ContractModule)
  },
  {
    path: 'portfolio',
    loadChildren: () =>
      import('src/app/portfolio/portfolio.module').then(
        mod => mod.PortfolioModule
      )
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('src/app/profile/profile.module').then(mod => mod.ProfileModule)
  },
  {
    path: 'news',
    loadChildren: () =>
      import('src/app/news/news.module').then(mod => mod.NewsModule)
  },
  { path: 'login', redirectTo: '/auth/sign-in' },
  { path: 'sign-in', redirectTo: '/auth/sign-in' },
  { path: 'signin', redirectTo: '/auth/sign-in' },
  { path: 'auth/login', redirectTo: '/auth/sign-in' },
  { path: 'auth/home', redirectTo: '/auth/sign-in' },

  { path: 'online', redirectTo: '/profile/detail' },

  { path: '', redirectTo: '/auth/sign-in', pathMatch: 'full' },
  // Otherwise Page Not Found
  { path: '**', redirectTo: '/error/page-not-found' }
];

@NgModule({
  exports: [RouterModule, AuthModule, ErrorModule],
  imports: [RouterModule.forRoot(routes, {})]
})
export class AppRoutingModule {}
